import { render, staticRenderFns } from "./BillingTotalsContainerComponent.vue?vue&type=template&id=e8ccdc26&scoped=true&lang=pug"
import script from "./BillingTotalsContainerComponent.vue?vue&type=script&lang=ts"
export * from "./BillingTotalsContainerComponent.vue?vue&type=script&lang=ts"
import style0 from "./BillingTotalsContainerComponent.vue?vue&type=style&index=0&id=e8ccdc26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ccdc26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8ccdc26')) {
      api.createRecord('e8ccdc26', component.options)
    } else {
      api.reload('e8ccdc26', component.options)
    }
    module.hot.accept("./BillingTotalsContainerComponent.vue?vue&type=template&id=e8ccdc26&scoped=true&lang=pug", function () {
      api.rerender('e8ccdc26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/BillingTotals/BillingTotalsContainerComponent.vue"
export default component.exports